import React, { useEffect } from "react";
import ComingSoon from "../views/comingsoon/ComingSoon";
import NotFound from "../views/Misc/NotFound";
import { Route, Switch, useLocation } from "react-router-dom";
import ScrollTopBehaviour from "../components/shared/ScrollTopBehaviour";

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search + location.hash,
        page_search: location.search,
        page_hash: location.hash,
      });
    }
  }, [location]);
};

const Routes = () => {
  return (
    <>
      <ScrollTopBehaviour />
      <Switch>
        <Route exact path="/" component={ComingSoon} />
        <Route component={NotFound} />
      </Switch>
    </>
  );
};

export default Routes;